import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { MAX_FILE_SIZE_IN_BYTES } from '../../../../../../constants/maxFileSizeInBytes'
import { AttachmentUploadErrorType } from '../../../../../../enums/attachmentUploadErrorType'
import { getFileSizeLabel } from '../../../../../../utils/getFileSizeLabel'
import { AttachmentTag } from '../../../AttachmentTag'

interface FailedAttachmentTagProps {
  errorType?: AttachmentUploadErrorType
  fileName: string
  isRetryable: boolean
  onRemove: () => void
  onRetry: () => void
}

export const FailedAttachmentTag = ({
  errorType,
  fileName,
  isRetryable,
  onRemove,
  onRetry,
}: FailedAttachmentTagProps): ReactElement => {
  const { t } = useTranslation()

  const maxSizeLabel = getFileSizeLabel(MAX_FILE_SIZE_IN_BYTES)
  const errorMessageTranslationKey =
    errorType === AttachmentUploadErrorType.Size
      ? 'attachments_list.upload.error.exceeded_max_file_size'
      : 'attachments_list.upload.error.failed'

  const errorMessage = t(errorMessageTranslationKey, { maxFileSize: maxSizeLabel })

  const handleRemove = useCallback(() => onRemove(), [onRemove])
  const handleRetry = useCallback(() => onRetry(), [onRetry])

  return (
    <AttachmentTag
      actionLabel={t('attachments_list.upload.try_again')}
      errorMessage={errorMessage}
      fileName={fileName}
      isActionClickable={isRetryable}
      onActionClick={handleRetry}
      onClose={handleRemove}
      variant="error"
    />
  )
}
